import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getInfo } from "@/api/OrderReview/index";
import { getFileUrl } from "@/utils/FileUtil";
import { Spin, Image } from "antd";
import CountryAreaTags from "@/components/CountryAdress/CountryAreaTags";
import { useMediaQuery } from "react-responsive";
import "./index.less";

const SupplyDemend = () => {
  const arrKey = [
    { name: "供应货品", desc: "产品详情", value: "supply" },
    { name: "需求货品", desc: "需求详情", value: "purchase" },
  ];
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');
  const demandType = urlParams.get('demandType');
  const keyType = demandType == 1 ? 'purchase' :'supply';
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [infoData, setInfoData] = useState({});
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const fetchInfo = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const res = await getInfo({ id: id });
        if (res?.code === "0") {
          const data = res?.data || {};
          setInfoData(data);

          const imageObjects = [];
          const imageInfos = [];

          // 处理封面图
          if (data.coverImg) {
            try {
              const coverImgArray = Array.isArray(data.coverImg)
                ? data.coverImg
                : JSON.parse(data.coverImg);

              imageInfos.push(
                ...coverImgArray.map((img) => img.filePath || img.url)
              );
            } catch (e) {
              console.warn("解析coverImg失败:", e);
            }
          }

          if (data.fileInfos) {
            try {
              const mainImgArray = Array.isArray(data.fileInfos)
                ? data.fileInfos
                : JSON.parse(data.fileInfos);

              imageObjects.push(
                ...mainImgArray.map((img) => img.filePath || img.url)
              );
            } catch (e) {
              console.warn("解析mainImgUrl失败:", e);
              imageObjects.push(
                ...data.fileInfos.split(",").filter((url) => url.trim())
              );
            }
          }
          const InfoImageUrls = [...new Set(imageObjects)].filter(
            (url) => url && url.trim()
          );
          if (InfoImageUrls.length > 0) {
            const imageUrlString = InfoImageUrls.join(",");
            const processedImages = await processImageUrls(imageUrlString);
            if (processedImages.length > 0) {
              setImages(processedImages);
            }
          } else {
            setImages([]);
          }
          const uniqueImageUrls = [...new Set(imageInfos)].filter(
            (url) => url && url.trim()
          );

          if (uniqueImageUrls.length > 0) {
            const imageUrlString = uniqueImageUrls.join(",");
            const processedImages = await processImageUrls(imageUrlString);
            if (processedImages.length > 0) {
              setSelectedImage(processedImages[0]);
            }
          } else {
            setSelectedImage(null);
          }
        }
      } catch (error) {
        console.error("请求出错:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInfo();
  }, [id]);

  const processImageUrls = async (imageUrlsString) => {
    if (!imageUrlsString) return [];

    const urls = imageUrlsString.split(",");
    const processedImages = [];

    for (let i = 0; i < urls.length; i++) {
      const trimmedUrl = urls[i].trim();
      try {
        const fullUrl = await getFileUrl(trimmedUrl);
        processedImages.push({
          id: i + 1,
          src: fullUrl,
          thumb: fullUrl,
          alt: `产品图片 ${i + 1}`,
        });
      } catch (error) {
        console.error("处理图片URL出错:", error);
        processedImages.push({
          id: i + 1,
          src: trimmedUrl,
          thumb: trimmedUrl,
          alt: `产品图片 ${i + 1}`,
        });
      }
    }

    return processedImages;
  };

  const handleImageSelect = (image) => {
    setSelectedImage(image);
  };

  return (
    <section className="demand-detail">
      <Spin
        spinning={loading}
        size="large"
        wrapperClassName="demand-detail-spin"
      >
        <div className="container-home-page">
          <div className="demand-container">
            <div className="demand-gallery">
              <div className="main-image">
                <Image
                  wrapperStyle={{
                    width: "100%",
                    height: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                  style={{
                    objectFit: "contain",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width: "auto",
                    height: "auto",
                  }}
                  src={selectedImage?.src || ""}
                  alt={selectedImage?.alt || ""}
                />
              </div>
              {/* <div className="image-thumbnails">
                {images.map((image) => (
                  <div
                    key={image.id}
                    className={`thumbnail ${
                      selectedImage.id === image.id ? "active" : ""
                      }`}
                    onClick={() => handleImageSelect(image)}
                  >
                    <img src={image.thumb} alt={image.alt} />
                  </div>
                ))}
              </div> */}
            </div>

            <div className="demand-info">
              <div className="demand-tag">
                {arrKey.find((item) => item.value === keyType)?.name}
              </div>
              <h1 className="demand-title">{infoData?.productTitle}</h1>
              <p className="demand-subtitle">{infoData?.shortDesc}</p>

              <div className="budget-section">
                <div className="budget-label">预算范围</div>
                <div className="budget">{infoData?.rangeOfBudget}</div>
                <div className="budget-note">
                  预算根据产品质量和定制要求浮动
                </div>
              </div>

              <div className="specs">
                {keyType === "purchase" ? (
                  <div>
                    <div className="spec-item">
                      <div className="spec-label">所在地区</div>
                      <CountryAreaTags value={infoData?.supplyAreas} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="spec-item">
                      <div className="spec-label">贸易区域</div>
                      <div className="spec-value">
                          <CountryAreaTags value={infoData?.supplyAreas} />
                      </div>
                    </div>
                    <div className="spec-item">
                      <div className="spec-label">供应地区</div>
                      <div className="spec-value">
                          <CountryAreaTags value={infoData?.producingAreas} />
                      </div>
                    </div>
                    <div className="spec-item">
                      <div className="spec-label">发货时间</div>
                      <div className="spec-value">{infoData?.deliveryTime}</div>
                    </div>
                    <div className="spec-item">
                      <div className="spec-label">最小起订量</div>
                      <div className="spec-value">{infoData?.minimumNum}</div>
                    </div>
                  </div>
                )}
                {(infoData?.specs || []).map((item, index) => (
                  <div className="spec-item" key={index}>
                    <div className="spec-label">{item.specType}</div>
                    <div className="spec-value">{item.value}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="demand-description">
            <h2 className="section-h2">
              {arrKey.find((item) => item.value === keyType)?.desc}
            </h2>
            <div className="contact-info">
              <p>{infoData?.productDesc}</p>
                <div className="info-images">
                {images.length > 0 &&
                  images.map((image) => (
                    <div key={image.id}>
                      <Image
                        wrapperStyle={{
                          width: "100%",
                          height: isMobile ? "170px" : "300px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          // backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          overflow: "hidden",
                          marginBottom: "16px",
                        }}
                        style={{
                          objectFit: "contain",
                          maxWidth: "100%",
                          maxHeight: "100%",
                          width: "auto",
                          height: "auto",
                        }}
                        src={image.thumb}
                        alt={image.alt}
                      />
                    </div>
                  ))}
              </div>
              <div className="contact-info-item">
                <div className="contact-info-label">公司/机构名称：</div>
                <div className="contact-info-value">{infoData?.compName}</div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-label">联系人：</div>
                <div className="contact-info-value">{infoData?.contact}</div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-label">联系电话：</div>
                <div className="contact-info-value">{infoData?.phoneNum}</div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-label">电子邮箱：</div>
                <div className="contact-info-value">{infoData?.email}</div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-label">微信/WhatsApp：</div>
                <div className="contact-info-value">
                  {infoData?.otherContact}
                </div>
              </div>
               <div className="contact-info-item">
                <div className="contact-info-label">业务编码：</div>
                <div className="contact-info-value">{infoData?.businessCode}</div>
              </div>
            </div>
          </div>

          
        </div>
      </Spin>
    </section>
  );
};

export default SupplyDemend;